import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HelperService} from '../../helpers';
import {ActivatedRoute, Router} from '@angular/router';
import {Observable, of} from 'rxjs';
import {PostNumbers, TimetableTypes} from '../../constants';
import {FormArray, FormBuilder, Validators} from '@angular/forms';
import {mergeMap} from 'rxjs/operators';
import {CurrencyPipe} from '@angular/common';

@Component({
  selector: 'app-unit',
  templateUrl: './unit.component.html',
  styleUrls: ['./unit.component.scss']
})
export class UnitComponent implements OnInit {

  public units: any = [];
  public unit: any;
  public contractorId = null;
  public contractor = null;

  public timetables: any = [];
  public services: any = [];
  public premiums: any = [];

  public timeTableTypes = Object.keys(TimetableTypes.types).map((key, index) => {
    return {
      label: TimetableTypes.types[key],
      value: key,
    };
  });

  public postNumbers = Object.keys(PostNumbers.numbers).map((key, index) => {
    return {
      name: PostNumbers.numbers[key],
      number: key,
      search: key + ' ' + PostNumbers.numbers[key] + '' + key
    };
  });

  public postNumbersFilter: Observable<any>;
  public posteFilter: Observable<any>;

  public form;
  public formSucces = false;
  public formError: string = null;
  public formProcessing = false;


  public loadingUnitData = false;
  public loadingTimeTableData = false;
  public loadingServicesData = false;

  constructor(
    private http: HttpClient,
    private helper: HelperService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private currencyPipe: CurrencyPipe,
  ) {
    this.initForm();

    this.postNumbersFilter = new Observable((observer: any) => {
      // Runs on every search
      observer.next(this.form.controls.postNumber.value);
    })
      .pipe(
        mergeMap((token: string): Observable<any> => {
          const query = new RegExp(token, 'i');

          return of(
            this.postNumbers.filter((poste: any) => {
              return query.test(poste.name) || query.test(poste.number);
            })
          );
        })
      );

    this.posteFilter = new Observable((observer: any) => {
      // Runs on every search
      observer.next(this.form.controls.poste.value);
    })
      .pipe(
        mergeMap((token: string): Observable<any> => {
          const query = new RegExp(token, 'i');

          return of(
            this.postNumbers.filter((poste: any) => {
              return query.test(poste.name) || query.test(poste.number);
            })
          );
        })
      );
  }

  initForm() {
    this.form = this.fb.group({
        title: this.fb.control('', Validators.required),
        address: this.fb.control(''),
        postNumber: this.fb.control(null),
        poste: this.fb.control(null),
        website: this.fb.control(null, Validators.pattern(
          /(((http|https):\/{2})((?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/)),
        email: this.fb.control(null, Validators.email),
        phoneNumber: this.fb.control(null),

        timetables: this.fb.array([]),
        services: this.fb.array([]),

        premium: this.fb.control(null),
      }
    );
  }

  ngOnInit() {
    this.route.parent.params.subscribe((params) => {
      if (params.contractor) {
        this.http.get(this.helper.getApiUrl('/zdravstvene-ustanove/' + params.contractor)).subscribe((contractor) => {
          this.contractor = contractor;
        });

        this.contractorId = params.contractor;
        this.http.get(
          this.helper.getApiUrl('/timetable?timetable_mainContractor=' + params.contractor)).subscribe(
          (timetables) => {
            this.timetables = timetables;
          });

        this.http.get(
          this.helper.getApiUrl('/premium?premium_mainContractor=' + params.contractor)).subscribe(
          (premiums) => {
            this.premiums = premiums;
          });
      }
    });
    this.route.params.subscribe((params) => {
      if (params.unit) {
        this.initForm();
        this.loadingUnitData = true;
        this.loadingServicesData = true;
        this.http.get(
          this.helper.getApiUrl('/enote/' + params.unit)).subscribe(
          (unit) => {
            this.unit = unit;

            this.form.controls.title.setValue(this.unit.title.raw);
            this.form.controls.address.setValue(this.unit.acf.contractorUnit_address.contractorUnit_address_address);
            this.form.controls.postNumber.setValue(
              this.unit.acf.contractorUnit_address.contractorUnit_address_postNumber);
            this.form.controls.poste.setValue(this.unit.acf.contractorUnit_address.contractorUnit_address_poste);
            this.form.controls.website.setValue(this.unit.acf.contractorUnit_url);
            this.form.controls.email.setValue(this.unit.acf.contractorUnit_email);
            this.form.controls.phoneNumber.setValue(this.unit.acf.contractorUnit_phoneNumber);

            this.form.controls.premium.setValue(this.unit.acf.contractorUnit_premiumAccount_relation.ID);

            if (!this.unit.acf.contractorUnit_timetable_universal) {
              this.unit.acf.contractorUnit_timetable_universal = [];
            }

            const timetables = this.form.get('timetables') as FormArray;
            this.unit.acf.contractorUnit_timetable_universal.forEach((tt) => {
              timetables.push(
                this.fb.group({
                  relation: tt.contractorUnit_timetable_universal_relation.ID,
                  name: tt.contractorUnit_timetable_universal_name,
                  phone: tt.contractorUnit_timetable_universal_phone,
                  email: [tt.contractorUnit_timetable_universal_email, Validators.email],
                  type: tt.contractorUnit_timetable_universal_type.value
                })
              );
            });

            this.loadingUnitData = false;

            this.http.get(
              this.helper.getManagerApiUrl('/enote/' + params.unit + '/services')).subscribe(
              (restServices) => {
                this.services = restServices;

                const services = this.form.get('services') as FormArray;
                this.services.forEach((sv) => {
                  const con = sv.concession === '1' ? true : false;
                  const sel = sv.selfFunding === '1' ? true : false;
                  services.push(
                    this.fb.group({
                      row_id: sv.row_id,
                      vzs_id: sv.service_vzs_sifra_vzs,
                      title: sv.post_title,
                      custom: sv.custom,
                      concession: con,
                      selfFunding: sel,
                      wp_2_contractor: [{value: sv.wp_2_contractor, disabled: !con}, Validators.pattern(/^[0-9]*$/)],
                      wp_3_contractor: [{value: sv.wp_3_contractor, disabled: !con}, Validators.pattern(/^[0-9]*$/)],
                      wp_7_contractor: [{ value: sv.wp_7_contractor, disabled: !con }, Validators.pattern(/^[0-9]*$/)],
                      wp_sf_contractor: [{value: sv.wp_sf_contractor, disabled: !sel}, Validators.pattern(/^[0-9]*$/)],
                      wp_sf_price_contractor: [{value: sv.wp_sf_price_contractor, disabled: !sel},
                        Validators.pattern(/^[0-9]+(\.[0-9]{1,2})?$/)],
                    })
                  );
                });
                this.loadingServicesData = false;
              });
          });
      }
    });
  }

  checkboxChange(event, type, index) {
    const timetables = this.form.get('services') as FormArray;

    switch (type) {
      case 'concession':
        if (timetables.controls[index].get('concession').value) {
          timetables.controls[index].get('wp_2_contractor').enable();
          timetables.controls[index].get('wp_3_contractor').enable();
          timetables.controls[index].get('wp_7_contractor').enable();
        } else {
          timetables.controls[index].get('wp_2_contractor').disable();
          timetables.controls[index].get('wp_3_contractor').disable();
          timetables.controls[index].get('wp_7_contractor').disable();
        }
        break;
      case 'sf':
        if (timetables.controls[index].get('selfFunding').value) {
          timetables.controls[index].get('wp_sf_contractor').enable();
          timetables.controls[index].get('wp_sf_price_contractor').enable();
        } else {
          timetables.controls[index].get('wp_sf_contractor').disable();
          timetables.controls[index].get('wp_sf_price_contractor').disable();
        }
        break;
    }
  }

  addTimetable() {
    const timetables = this.form.get('timetables') as FormArray;
    timetables.push(
      this.fb.group({
        relation: null,
        name: null,
        phone: null,
        email: [null, Validators.email],
        type: 1
      })
    );
  }

  removeTimetable(index) {
    const timetables = this.form.get('timetables') as FormArray;
    timetables.removeAt(index);
  }

  currencyChanged(item) {
    item.setValue(this.currencyPipe.transform(item.value.replace(',', '.'), '', '', '0.2-2', 'sl'));
  }

  onPostSelect(event) {
    this.form.controls.postNumber.setValue(event.item.number);
    this.form.controls.poste.setValue(event.item.name);
  }

  update(form) {
    this.formSucces = false;
    this.formError = null;

    if (!this.form.valid) {
      this.formError = 'Preverite vpisane podatke.';
      return;
    }

    this.formProcessing = true;

    const data = {
      title: this.form.controls.title.value,
      fields: {
        contractorUnit_address: {
          contractorUnit_address_address: this.form.controls.address.value,
          contractorUnit_address_postNumber: this.form.controls.postNumber.value,
          contractorUnit_address_poste: this.form.controls.poste.value
        },
        contractorUnit_phoneNumbers: [],
        contractorUnit_emails: [],
        contractorUnit_url: this.form.controls.website.value,
        contractorUnit_email: this.form.controls.email.value,
        contractorUnit_phoneNumber: this.form.controls.phoneNumber.value,
        contractorUnit_timetable_universal: [],
        contractorUnit_premiumAccount_relation: this.form.controls.premium.value,
      },
    };

    const timetables = this.form.get('timetables') as FormArray;
    timetables.controls.forEach((control) => {
      data.fields.contractorUnit_timetable_universal.push({
        contractorUnit_timetable_universal_relation: control.value.relation,
        contractorUnit_timetable_universal_name: control.value.name,
        contractorUnit_timetable_universal_phone: control.value.phone,
        contractorUnit_timetable_universal_email: control.value.email,
        contractorUnit_timetable_universal_type: control.value.type,
      });
    });

    const servicesData = [];

    const services = this.form.get('services') as FormArray;
    services.controls.forEach((control) => {
      servicesData.push({
        id: control.value.row_id,
        custom: control.value.custom,
        wp_2_contractor: control.value.wp_2_contractor,
        wp_3_contractor: control.value.wp_3_contractor,
        wp_7_contractor: control.value.wp_7_contractor,
        wp_sf_contractor: control.value.wp_sf_contractor,
        wp_sf_price_contractor: control.value.wp_sf_price_contractor,
        concession: control.value.concession,
        selfFunding: control.value.selfFunding,
      });
    });

    this.http.put(
      this.helper.getManagerApiUrl('/enote/' + this.unit.id + '/services'), servicesData).subscribe(() => {
    });


    this.http.put(this.helper.getApiUrl('/enote/' + this.unit.id), data).subscribe(
      (unit) => {
        this.formProcessing = false;
        this.formSucces = true;
      }, (error) => {
        this.formProcessing = false;
        this.formError = 'Pri shranjevanju podatkov je prišlo do napake.';
      });
  }
}
